module.exports = [{
      plugin: require('/Users/bh/Documents/Sourcetree/mounteveresthermanus-coza/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
